<div class="pa-tab" [ngClass]="{ 'pa-tab--link': routerLink }">
  <p-tab [value]="value" [disabled]="disabled">
    <span
      class="pa-tab-content-wrap"
      routerLinkActive="p-highlight"
      [routerLinkActiveOptions]="{
        paths: 'exact',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored'
      }"
    >
      <span *ngIf="!routerLink" class="pa-tab-content">
        <ng-container *ngTemplateOutlet="tabInner"></ng-container>
      </span>

      <a
        *ngIf="routerLink"
        class="pa-tab-content"
        [routerLink]="routerLink"
        (click)="$event.stopPropagation()"
      >
        <ng-container *ngTemplateOutlet="tabInner"></ng-container>
      </a>

      <i
        *ngIf="tooltip"
        class="pi pi-question-circle pa-tab-tooltip"
        [pTooltip]="tooltip"
        tooltipEvent="focus"
        tooltipPosition="bottom"
        tooltipStyleClass="pa-tab-tooltip-overlay"
        appendTo="body"
        hideDelay="300"
        [attr.tabindex]="0"
        (click)="handleTooltipInteraction($event)"
        (pointerdown)="handleTooltipInteraction($event)"
        (mouseenter)="handleTooltipMouseEnter()"
        (mouseleave)="handleTooltipMouseLeave()"
      ></i>
    </span>

    <ng-template #tabInner>
      <span>
        <ng-content></ng-content>
      </span>

      <span *ngIf="loading" class="ml-8 pa-tab-loading">
        <ion-spinner></ion-spinner>
      </span>

      <ng-container *ngIf="!loading">
        <pa-tag
          *ngIf="isNew"
          class="ml-8"
          size="small"
          value="новое"
          severity="danger"
        ></pa-tag>

        <pa-tag
          *ngIf="shouldShowBadge() && userService.data.subActive"
          class="ml-8"
          size="small"
          [value]="formatBadge(badge)"
          [rounded]="true"
          severity="primary"
        ></pa-tag>

        <pa-tag
          *ngIf="isProfi"
          class="ml-8"
          title='Доступно только на тарифе "ПРОФИ"'
          severity="profi"
        ></pa-tag>
      </ng-container>
    </ng-template>
  </p-tab>
</div>
